export const HEAD_CELLS = [
  {
    id: 'id',
    label: 'ID шаблона',
  },
  {
    id: 'name',
    label: 'Наименование'
  },
  {
    id: 'created_at',
    label: 'Дата создания'
  },
  {
    id: 'category',
    label: 'Категория кампании',
  },
  {
    id: 'type',
    label: 'Тип рассылки',
  },
  {
    id: 'status',
    label: 'Статус'
  },
  {
    id: '',
    label: '',
    hideSortIcon: true
  }
];
